import React from "react";
import { STRINGS } from "../strings";
import { delay } from "../system/delay";
import { translate } from "../translate";
import { setStatusBarAsOverlayWhite } from "../utils/statusBar";
import { PIN_LENGTH } from "./PinInput";
import InvalidPinModal from "./PinUnlockScreen/components/InvalidPinModal";
import SetPinScreen from "./SetPinScreen";

interface Props {
  onDone: (pin: string) => void;
}

const SetPinActivity = (props: Props) => {
  const [chosenPin, setChosenPin] = React.useState<string | null>(null);
  const [pinValue, setPinValue] = React.useState("");
  const [error, setError] = React.useState<string>();

  React.useEffect(() => {
    setTimeout(setStatusBarAsOverlayWhite, 0);
  }, []);

  const handleRequestCloseInvalidModal = React.useCallback(() => setError(undefined), []);

  const handleChangePin = React.useCallback(
    async (val: string) => {
      setPinValue(val);

      if (val.length !== PIN_LENGTH) {
        return;
      }

      // I'm delaying the action so the user will be able to see the fourth digit visually
      await delay(250);

      if (chosenPin === null) {
        setChosenPin(val);
        setPinValue("");
        return;
      }

      if (val !== chosenPin) {
        setError(translate(STRINGS.YOU_DID_NOT_ENTER_THE_SAME_PIN_CODE_PLEASE_TRY_AGAIN));
        setChosenPin(null);
        setPinValue("");
        return;
      }

      props.onDone.call(null, chosenPin);
    },
    [chosenPin, props.onDone]
  );

  return (
    <>
      <SetPinScreen chosenPin={chosenPin} pinValue={pinValue} onChange={handleChangePin} />
      <InvalidPinModal error={error} onRequestClose={handleRequestCloseInvalidModal} />
    </>
  );
};

export default React.memo(SetPinActivity);
